<template>
  <div>
    <el-form
      :model="operationForm"
      :rules="rules"
      ref="operationForm"
      label-width="140px"
      class="demo-ruleForm"
    >
      <el-form-item label="操作名称：" prop="title">
        <el-input
          v-model.trim="operationForm.title"
          placeholder="请输入操作名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="考核地点：" prop="address">
        <el-input
          v-model.trim="operationForm.address"
          placeholder="请输入考核地点"
        ></el-input>
      </el-form-item>
      <el-form-item label="考核时间：" prop="time">
        <el-date-picker
          v-model="operationForm.time"
          type="datetimerange"
          range-separator="至"
          start-placeholder="创建开始日期"
          end-placeholder="创建结束日期"
          value-format="yyyy-MM-dd HH:mm:ss"
          :picker-options="$route.query.type == 0 ? pickerOptions0 : ''"
          :default-time="['00:00:00', '23:59:59']"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="考核内容：" prop="contentTxt">
        <el-input
          type="textarea"
          v-model.trim="operationForm.contentTxt"
          placeholder="请输入考核内容"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="关联操作考核表："
        class="text_one"
        v-if="tagState == false"
      >
        <el-button @click="addTable">添加关联表</el-button>
        <!-- <p style="color: #999999" v-else>
          当前只能关联一张考核表，需要关联其他的表需要删掉之前关联的表格
        </p> -->
      </el-form-item>
      <el-form-item label="关联操作评分表：" class="text_one" v-else>
        <el-tag
          v-if="tagState == true"
          closable
          :disable-transitions="false"
          @close="handleClose()"
          >{{ titleName }}</el-tag
        >
        <!-- rowObj.Title  -->
      </el-form-item>
    </el-form>
    <!-- 弹窗 -->
    <TabPopup ref="tabPopup" @list="getlist" />
  </div>
</template>

<script>
import TabPopup from "./TabPopup.vue";
import assessApi from "@/api/assessment";
import loginvuex from "@/store/index";
export default {
  data() {
    return {
      operationForm: {
        title: "", // 操作名称
        address: "", // 操作地点
        time: [], // 考核时间
        beginTime: "", // 开始时间
        endTime: "", // 结束时间
        contentTxt: "", // 考核内容
        scoreID: "", // 评分表ID
      },
      titleName: "", // 关联表气泡
      tagState: false, // 是否有标签
      placeArr: [],
      // 禁用当前前面的时间日期
      pickerOptions0: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7; //如果没有后面的-8.64e7就是不可以选择今天的
        },
      },
      rules: {
        title: [{ required: true, message: "请输入操作名称", trigger: "blur" }],
        address: [
          { required: true, message: "请选择操作地点", trigger: "change" },
        ],
        time: [
          { required: true, message: "请选择考核时间", trigger: "change" },
        ],
        contentTxt: [
          { required: true, message: "请输入考核内容", trigger: "blur" },
        ],
        associated: [
          { required: true, message: "请输入操作名称", trigger: "blur" },
        ],
      },
      rowObj: {},
    };
  },
  components: {
    TabPopup,
  },
  props: ["editorObj"],
  methods: {
    // 关闭标签
    handleClose() {
      this.tagState = false;
      this.$refs.tabPopup.radio = "";
      this.titleName = ""; // 清除勾选数据
      if (this.$route.query.type == 1) {
        // this.$refs.tabPopup.multipleSelection = [];
        this.rowObj = {};
      }
    },
    getlist(row) {
      this.tagState = true;
      this.rowObj = row;
    },
    submitForm() {
      this.$refs["operationForm"].validate(async (valid) => {
        if (valid) {
          // alert("submit!");
          if (this.titleName == "") {
            this.$message({
              message: "警告，当前未关联评分表",
              type: "warning",
            });
          } else {
            // 验证名称是否重复
            if (this.$route.query.type == 0 || this.$route.query.type == 2) {
              let obj = {
                title: this.operationForm.title,
                guid: JSON.parse(loginvuex.state.userlist).guid,
                userID: JSON.parse(loginvuex.state.userlist).userID,
              };
              const { data } = await assessApi.examineTitle(obj);
              if (data.Status == 200) {
                this.operationData(); // 跳转
              } else {
                this.$message.error(data.Msg);
              }
            } else {
              this.operationData(); // 编辑不验证
            }
            return;
          }
          return true;
        } else {
          return false;
        }
      });
    },
    // 下一步
    operationData() {
      // console.log(this.operationForm.scoreID);
      this.operationForm.scoreID = this.operationForm.scoreID;
      // console.log( this.operationForm.scoreID,this.rowObj);
      this.operationForm.beginTime = JSON.parse(
        JSON.stringify(this.operationForm.time[0])
      );
      this.operationForm.endTime = JSON.parse(
        JSON.stringify(this.operationForm.time[1])
      );
      this.$parent.active = 1;
    },
    // 添加关联表
    addTable() {
      /*
      1.拿到子组件的列表数组
      2.拿编辑ID匹配找到对应的row
      3.push到勾选的数组里
      */
      this.$refs.tabPopup.dialogVisibleObj.addAssociative = true; // 唤起弹窗
      this.$refs.tabPopup.getDatalist();
    },
    // 验证名称是否重复
    async validationNmae() {
      if (this.$route.query.type == 0 || this.$route.query.type == 2) {
      }
    },
    // 编辑回显
    editorEcho() {
      if (this.$route.query.type == 1 || this.$route.query.type == 2) {
        let row = this.editorObj;
        this.operationForm = {
          title: row.Title, // 操作名称
          address: row.Address, // 操作地点
          time: [], // 考核时间
          beginTime: "", // 开始时间
          endTime: "", // 结束时间
          contentTxt: row.ContentTxt, // 考核内容
          scoreID: row.ScoreID, // 评分表ID
        };
        this.tagState = true;
        this.titleName = row.ScoreTitle; // 气泡回显
        this.operationForm.scoreID = row.ScoreID; // 关联表ID回显
        // this.rowObj.Title = row.ScoreTitle;
        this.$nextTick(() => {
          // this.$refs.tabPopup.editorList("father");
        });
        if (
          this.$route.query.type == 2 &&
          (row.Title.indexOf("补考") != -1) == false
        ) {
          this.operationForm.title = row.Title + "(补考)";
        }
        this.operationForm.time[0] = this.$moment(row.BeginTime).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        this.operationForm.time[1] = this.$moment(row.EndTime).format(
          "YYYY-MM-DD HH:mm:ss"
        );
      }
    },
  },
  created() {
    this.editorEcho();
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-form {
  margin-left: 105px;
  margin-top: 40px;
  .el-input__inner {
    width: 366px;
    height: 40px;
  }
  .el-textarea__inner {
    width: 366px;
    height: 100px;
  }
  .el-form-item__label {
    text-align: left;
  }
  .el-button {
    background: #0084ea;
    color: #fff;
  }
  .el-date-editor .el-range-separator {
    padding: 0 !important;
  }
}
.text_one {
  // display: inline-block;
  margin: 0px 10px 0px 10px;
  min-width: 80px;
  font-size: 14px;
  line-height: 40px;
  position: relative;
  &::after {
    content: "*";
    position: absolute;
    display: block;
    left: -10px;
    top: 0;
    color: red;
    font-size: 16px;
  }
}
</style>
